import { render } from "./Allergy.vue?vue&type=template&id=37a4e991&scoped=true"
import script from "./Allergy.vue?vue&type=script&lang=js"
export * from "./Allergy.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=37a4e991&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=1&id=37a4e991&scoped=true&lang=css"
import "./Allergy.vue?vue&type=style&index=2&id=37a4e991&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a4e991"]])

export default __exports__